import AxiosControl from '../context/axios/AxiosControl'
const Axios = AxiosControl()

export const getSelections = (school) => async (dispatch) => {
    dispatch({
        type: 'SELECTION_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/client/selection/getbyschool/'+ school, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'SELECTION_GETALL_SUCCESS',
                payload: data.selections
            })
            dispatch({
                type: 'CALENDAR_GETALL_SUCCESS',
                payload: data.calendars
            })
        }
    } catch (error) {
        dispatch({
            type: 'SELECTION_NOT_LOADING'
        })
    }
}
export const getCurrentSelectionsBySchool = (school) => async (dispatch) => {
    dispatch({
        type: 'SELECTION_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/client/selection/getcurrentbyschool/'+ school, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'SELECTION_GETALL_SUCCESS',
                payload: data.selections
            })
        }
    } catch (error) {
        dispatch({
            type: 'SELECTION_NOT_LOADING'
        })
    }
}
export const getFinishedSelectionsBySchool = (school) => async (dispatch) => {
    dispatch({
        type: 'SELECTION_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/client/selection/getfinishedbyschool/'+ school, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'SELECTION_GETALL_SUCCESS',
                payload: data.selections
            })
        }
    } catch (error) {
        dispatch({
            type: 'SELECTION_NOT_LOADING'
        })
    }
}

export const getCurrentSelectionsAdmin = () => async (dispatch) => {
    dispatch({
        type: 'SELECTION_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/client/selection/getcurrent', {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'SELECTION_GETALL_SUCCESS',
                payload: data.selections
            })
        }
    } catch (error) {
        dispatch({
            type: 'SELECTION_NOT_LOADING'
        })
    }
}

export const getFinishedSelectionsAdmin = () => async (dispatch) => {
    dispatch({
        type: 'SELECTION_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/client/selection/getfinished', {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'SELECTION_GETALL_SUCCESS',
                payload: data.selections
            })
        }
    } catch (error) {
        dispatch({
            type: 'SELECTION_NOT_LOADING'
        })
    }
}

export const getSelection = (selection) => async (dispatch) => {
    dispatch({
        type: 'SELECTION_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/client/selection/get/'+ selection, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'SELECTION_GET_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'SELECTION_NOT_LOADING'
        })
    }
}

export const addProfileTypeSelection = (profileTypedata, school) => async (dispatch) => {
    dispatch({
        type: 'SELECTION_LOADING'
    })
    try {
        const { data, status } = await Axios.post('/api/client/selection/register', {school: school, profiletypedata: profileTypedata}, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'SELECTION_ADD_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'SELECTION_NOT_LOADING'
        })
    }
}
export const editProfileTypeSelection = (profileTypedata, selection) => async (dispatch) => {
    dispatch({
        type: 'SELECTION_LOADING'
    })
    try {
        const { data, status } = await Axios.put('/api/client/selection/edit/'+ selection, {profiletypedata: profileTypedata}, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'SELECTION_EDIT_SUCCESS',
                payload: data
            })
            dispatch({
                type: 'SELECTION_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'SELECTION_NOT_LOADING'
        })
    }
}

export const finishSelection = (selection) => async (dispatch) => {
    dispatch({
        type: 'SELECTION_LOADING'
    })
    try {
        const { data, status } = await Axios.put('/api/client/selection/finishselection/'+ selection, {},{
            headers: { auth: sessionStorage.getItem('jwt') }
        })
        if (status === 200 || status === 264) {
            dispatch({
                type: 'SELECTION_EDIT_SUCCESS',
                payload: data
            })
            dispatch({
                type: 'SELECTION_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'SELECTION_NOT_LOADING'
        })
    }
}

export const reactivateSelection = (selection) => async (dispatch) => {
    dispatch({
        type: 'SELECTION_LOADING'
    })
    try {
        const { data, status } = await Axios.put('/api/client/selection/reactivateselection/'+ selection, {},{
            headers: { auth: sessionStorage.getItem('jwt') }
        })
        if (status === 200 || status === 264) {
            dispatch({
                type: 'SELECTION_EDIT_SUCCESS',
                payload: data
            })
            dispatch({
                type: 'SELECTION_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'SELECTION_NOT_LOADING'
        })
    }
}

export const addPrecandidate = (selection, candidate) => async (dispatch) => {
    dispatch({
        type: 'SELECTION_LOADING'
    })
    try {
        const { data, status } = await Axios.put('/api/client/selection/addPrecandidate', {selection, candidate},{
            headers: { auth: sessionStorage.getItem('jwt') }
        })
        if (status === 200 || status === 264) {
            dispatch({
                type: 'SELECTION_ADD_PRECANDIDATE_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'SELECTION_NOT_LOADING'
        })
    }
}



export const removePrecandidate = (selection, candidate) => async (dispatch) => {
    dispatch({
        type: 'SELECTION_LOADING'
    })
    try {
        const { data, status } = await Axios.put('/api/client/selection/removePrecandidate', {selection, candidate},{
            headers: { auth: sessionStorage.getItem('jwt') }
        })
        if (status === 200 || status === 264) {
            dispatch({
                type: 'SELECTION_REMOVE_PRECANDIDATE_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'SELECTION_NOT_LOADING'
        })
    }
}

export const getPrecandidates = (selection) => async (dispatch) => {
    dispatch({
        type: 'SELECTION_PRECANDIDATES_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/client/selection/getPrecandidates/'+ selection, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'SELECTION_PRECANDIDATES_GET_SUCCESS',
                payload: data?.precandidates || []
            })
        }
    } catch (error) {
        dispatch({
            type: 'SELECTION_PRECANDIDATES_NOT_LOADING'
        })
    }
}

export const getPrecandidatesByPage = (selection, page) => async (dispatch) => {
    dispatch({
        type: 'SELECTION_PRECANDIDATES_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/client/selection/getPrecandidatesByPage/'+ selection + '/' + page, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'SELECTION_MORE_PRECANDIDATES_GET_SUCCESS',
                payload: data?.precandidates || []
            })
        }
    } catch (error) {
        dispatch({
            type: 'SELECTION_PRECANDIDATES_NOT_LOADING'
        })
    }
}

export const getActiveSelectionsByCandidate = (userId) => async (dispatch) => {
    dispatch({
        type: 'SELECTION_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/client/selection/getActiveByCandidate/'+ userId, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'SELECTION_GETALL_SUCCESS',
                payload: data.selections
            })
        }
    } catch (error) {
        dispatch({
            type: 'SELECTION_NOT_LOADING'
        })
    }
}

export const getAvailableSelectionsByCandidate = (userId) => async (dispatch) => {
    dispatch({
        type: 'SELECTION_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/client/selection/getAvailableByCandidate/'+ userId, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'SELECTION_GETALL_SUCCESS',
                payload: data.selections
            })
        }
    } catch (error) {
        dispatch({
            type: 'SELECTION_NOT_LOADING'
        })
    }
}

export const getReducedAvailableSelectionsByCandidate = (userId) => async (dispatch) => {
    dispatch({
        type: 'SELECTION_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/client/selection/getReducedAvailableByCandidate/'+ userId, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'SELECTION_GETALL_SUCCESS',
                payload: data.selections
            })
        }
    } catch (error) {
        dispatch({
            type: 'SELECTION_NOT_LOADING'
        })
    }
}

export const getFinishedSelectionsByCandidate = (userId) => async (dispatch) => {
    dispatch({
        type: 'SELECTION_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/client/selection/getFinishedByCandidate/'+ userId, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'SELECTION_GETALL_SUCCESS',
                payload: data.selections
            })
        }
    } catch (error) {
        dispatch({
            type: 'SELECTION_NOT_LOADING'
        })
    }
}



export const getRequestsSentByCandidate = (userId) => async (dispatch) => {
    dispatch({
        type: 'SELECTION_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/client/selection/getRequestsSentByCandidate/'+ userId, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'SELECTION_GETALL_SUCCESS',
                payload: data.selections
            })
        }
    } catch (error) {
        dispatch({
            type: 'SELECTION_NOT_LOADING'
        })
    }
}

export const getDescriptionByAI = (selection) => async (dispatch) => {
    dispatch({
        type: 'SELECTION_IA_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/client/selection/getDescriptionByAI/' + selection, {
            headers: { auth: sessionStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'SELECTION_DESCRIPTION_GET_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'SELECTION_IA_NOT_LOADING'
        })
    }
}

export const cloneSelection = (selectionId) => async (dispatch) => {
    dispatch({
        type: 'SELECTION_LOADING'
    })
    try {
        const { data, status } = await Axios.post('/api/client/selection/cloneSelection', {selectionId: selectionId}, {
            headers: { auth: sessionStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'SELECTION_CLONE_SUCCESS',
                payload: data
            })
            dispatch({
                type: 'SELECTION_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'SELECTION_NOT_LOADING'
        })
    }
}

export const getSelectionsByMultiSchool = (userId) => async (dispatch) => {
    dispatch({
        type: 'SELECTION_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/client/selection/getByMultiSchool/'+ userId, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'SELECTION_GETALL_SUCCESS',
                payload: data.selections
            })
            dispatch({
                type: 'CALENDAR_GETALL_SUCCESS',
                payload: data.calendars
            })
        }
    } catch (error) {
        dispatch({
            type: 'SELECTION_NOT_LOADING'
        })
    }
}